import React from 'react';
import { useField } from 'formik';
import './TextArea.scss';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import InfoIcon from '../../../../src/assets/icons/ic-info.svg';

interface IProps {
  name: string;
  toolTipText?: string;
  isGrid?: boolean;
  labelText: string;
  disabled?: boolean;
  required?: boolean;
  backgroundColour?: string | null;
}

export const Textarea = ({
  name,
  labelText,
  toolTipText,
  isGrid,
  disabled = false,
  required = false,
  backgroundColour,
}: IProps) => {
  const [field, meta] = useField(name);

  return (
    <div className="form-group from-group-textarea">
      <div className="label-wrapper">
        {required && <span className="required-indicator">*</span>}
        {labelText && <label htmlFor={field.name}>{labelText}</label>}
        {toolTipText && !isGrid && (
          <>
            <OverlayTrigger
              placement="top"
              overlay={
                <Tooltip id={`tooltip-${field.name}`}>{toolTipText}</Tooltip>
              }
            >
              <img
                src={InfoIcon}
                alt="info img"
                className="tooltip-trigger"
                data-toggle="tooltip"
              />
            </OverlayTrigger>
          </>
        )}
      </div>
      <textarea
        className={`form-control ${meta.error && 'is-invalid'}`}
        style={{ backgroundColor: backgroundColour || undefined }}
        id={field.name}
        {...field}
        value={field?.value || ''}
        disabled={disabled}
      />
      {meta.error && <p className="error-wrapper">{meta.error}</p>}
    </div>
  );
};
